<template>
  <v-container id="vendor-edit" fluid tag="section">
    <v-row>
      <v-col cols="12" md="12" v-if="vendor">
        <v-card>
          <template v-slot:heading>
            <div class="display-2 font-weight-light">
              {{ $i18n.t("Edit Vendor - ") + vendor.name }}
            </div>
          </template>

          <keep-alive>
            <v-tabs v-model="tab" class="elevation-2" icons-and-text>
              <v-tab v-for="(t, i) in tabs" :key="i" :href="`#tab-${i}`">
                {{ t.name }}
                <v-icon>{{ t.icon }}</v-icon>
              </v-tab>

              <v-tab-item v-for="(t, i) in tabs" :key="i" :value="'tab-' + i">
                <v-card flat tile v-if="t.name == 'Profile'">
                  <v-card-text>
                    <v-form id="form">
                      <v-container class="py-0" style="font-size: 12px">
                        <v-row>
                          <v-col cols="12" md="3">
                            <v-text-field
                              v-model="vendor.name"
                              :label="$i18n.t('Organization Name(Short)')"
                            />
                          </v-col>
                          <v-col cols="12" md="3">
                            <v-text-field
                              v-model="vendor.fullName"
                              :label="$i18n.t('Organization Full Name')"
                            />
                          </v-col>
                          <v-col cols="12" md="3">
                            <v-text-field
                              v-model="vendor.unique_id"
                              :label="$i18n.t('Unique Id')"
                              disabled
                            />
                          </v-col>
                          <v-col cols="12" md="3">
                            {{ $i18n.t("Created At") }} :
                            {{ vendor.createdOn | moment("HH:mm DD MMM YYYY") }}
                          </v-col>
                        </v-row>
                        <v-row class="mt-2" v-if="false && vendor.adminUser">
                          <v-col cols="12" sm="4" md="4" lg="4">
                            {{ $i18n.t("Admin Name") }}:
                            <b>{{ vendor.adminUser.name }}</b>
                          </v-col>
                          <v-col cols="12" sm="4" md="4" lg="4">
                            {{ $i18n.t("Admin Email") }}:
                            <b>{{ vendor.adminUser.email }}</b>
                          </v-col>
                          <v-col cols="12" sm="3" md="3" lg="3">
                            {{ $i18n.t("Admin Phone") }}:
                            <b>
                              {{ vendor.adminUser.countryCode }}
                              {{ vendor.adminUser.phone }}
                            </b>
                          </v-col>
                          <v-col
                            cols="12"
                            sm="1"
                            md="1"
                            lg="1"
                            v-if="vendor.adminUser._id"
                          >
                            <v-btn
                              text
                              fab
                              x-small
                              color="blue"
                              :to="
                                '/settings/supervisor/' + vendor.adminUser._id
                              "
                              :target="singlePage ? '_blank' : ''"
                            >
                              <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                          </v-col>
                        </v-row>
                        <v-row class="mt-2" v-if="false && vendor.address">
                          <v-col cols="12" sm="11" md="11" lg="11">
                            {{ $i18n.t("Address") }}:
                            <b>{{ vendor.address.addressLine }}</b
                            >, <b>{{ vendor.address.city }}</b
                            >, <b>{{ vendor.address.state }}</b
                            >,
                            <b>{{ vendor.address.country }}</b>
                          </v-col>
                          <v-col
                            cols="12"
                            sm="1"
                            md="1"
                            lg="1"
                            v-if="vendor.entity_id"
                          >
                            <v-btn
                              text
                              fab
                              x-small
                              color="blue"
                              :to="'/entity/' + vendor.entity_id"
                              :target="singlePage ? '_blank' : ''"
                            >
                              <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" class="text-right">
                            <v-btn
                              color="success"
                              class="mr-0"
                              @click="save()"
                              :loading="loading"
                            >
                              <h3>{{ $i18n.t("Save") }}</h3>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-form>
                  </v-card-text>
                </v-card>

                <v-card flat tile v-if="t.name == 'Profile'">
                  <v-card-text class="mt-10">
                    <v-btn
                      color="blue"
                      x-small
                      class="absolute-client-headers"
                      @click="addnewEntity = !addnewEntity"
                    >
                      <!-- :to="'/entity/create?forCorp=' + vendor._id"
                      :target="singlePage ? '_blank' : ''" -->
                      <h3>
                        {{
                          addnewEntity ? $i18n.t("Hide") : $i18n.t("Add New")
                        }}
                      </h3>
                    </v-btn>
                    <div v-if="addnewEntity">
                      <entity-edit
                        :forClient="vendor._id"
                        :singlePage="singlePage"
                        @reload="getEntitiesbyCORP(vendor._id)"
                      />
                    </div>
                    <v-simple-table>
                      <thead>
                        <tr>
                          <th class="primary--text">{{ $i18n.t("Name") }}</th>
                          <th class="primary--text">{{ $i18n.t("GSTIN") }}</th>
                          <th class="primary--text">{{ $i18n.t("RCM") }}</th>
                          <th class="primary--text">{{ $i18n.t("SEZ") }}</th>
                          <th class="primary--text">{{ $i18n.t("Prefix") }}</th>
                          <th class="primary--text">
                            {{ $i18n.t("Reset Invoice") }}
                          </th>
                          <th class="primary--text">
                            {{ $i18n.t("Location") }}
                          </th>
                          <th class="primary--text">
                            {{ $i18n.t("Contact Person") }}
                          </th>
                          <th class="primary--text">
                            {{ $i18n.t("Details") }}
                          </th>
                          <th class="primary--text"></th>
                        </tr>
                      </thead>

                      <entity-row
                        v-for="bu in entityList"
                        :key="bu._id"
                        :value="bu"
                        :singlePage="singlePage"
                      />
                    </v-simple-table>
                  </v-card-text>
                </v-card>

                <v-card flat tile v-if="false && t.name == 'Entities'">
                  <v-card-text>
                    <v-btn
                      color="blue"
                      x-small
                      style="float: right"
                      class="absolute-client-headers"
                      :to="'/entity/create?forCorp=' + vendor._id"
                      :target="singlePage ? '_blank' : ''"
                    >
                      <h3>{{ $i18n.t("Add New") }}</h3>
                    </v-btn>
                    <v-simple-table>
                      <thead>
                        <tr>
                          <th class="primary--text">{{ $i18n.t("Name") }}</th>
                          <th class="primary--text">{{ $i18n.t("GSTIN") }}</th>
                          <th class="primary--text">{{ $i18n.t("RCM") }}</th>
                          <th class="primary--text">{{ $i18n.t("SEZ") }}</th>
                          <th class="primary--text">{{ $i18n.t("Prefix") }}</th>
                          <th class="primary--text">
                            {{ $i18n.t("Reset Invoice") }}
                          </th>
                          <th class="primary--text">
                            {{ $i18n.t("Location") }}
                          </th>
                          <th class="primary--text"></th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr v-for="(bu, index) in entityList" :key="index">
                          <td>
                            <v-icon
                              v-if="bu.isDefault"
                              color="light-blue"
                              :title="$i18n.t('Default Entity')"
                              >mdi-police-badge</v-icon
                            >
                            {{ bu.name }}
                          </td>
                          <td>{{ bu.gstin }}</td>
                          <td>
                            <v-icon v-if="bu.rcmApplicable">mdi-check</v-icon>
                            <v-icon v-if="!bu.rcmApplicable">mdi-close</v-icon>
                          </td>
                          <td>
                            <v-icon v-if="bu.underSEZ">mdi-check</v-icon>
                            <v-icon v-if="!bu.underSEZ">mdi-close</v-icon>
                          </td>
                          <td>
                            {{
                              bu.invoicePrefix
                                ? "Prefix : " + bu.invoicePrefix
                                : ""
                            }}
                            {{
                              bu.invoicePrefix && bu.invoicePrefixSEZ ? "|" : ""
                            }}
                            {{
                              bu.invoicePrefixSEZ
                                ? "SEZ Prefix :" + bu.invoicePrefixSEZ
                                : ""
                            }}
                          </td>
                          <td>
                            <v-icon v-if="bu.resetInvoiceNoInApril"
                              >mdi-check</v-icon
                            >
                            <v-icon v-if="!bu.resetInvoiceNoInApril"
                              >mdi-close</v-icon
                            >
                          </td>
                          <td>
                            {{ bu.address.city }}, {{ bu.address.state }},
                            {{ bu.address.country }}
                          </td>
                          <td>
                            <v-btn
                              class="float-right"
                              color="primary"
                              small
                              fab
                              text
                              dark
                              :to="'/entity/' + bu._id"
                              :target="singlePage ? '_blank' : ''"
                            >
                              <v-icon>mdi-pencil</v-icon>
                            </v-btn>

                            <z-confirm-button
                              v-if="!bu.isDefault"
                              class="float-right"
                              color="red"
                              small
                              fab
                              text
                              dark
                              :loading="loading"
                              :message="
                                $i18n.t('Do you want to delete this Entity ?')
                              "
                              @click="deleteEntity(bu)"
                            >
                              <v-icon>mdi-trash-can-outline</v-icon>
                            </z-confirm-button>

                            <z-confirm-button
                              v-if="!bu.isDefault"
                              class="float-right"
                              color="info"
                              small
                              fab
                              text
                              dark
                              :loading="loading"
                              :message="
                                $i18n.t(
                                  'Do you want to mark this Entity as Primary ?'
                                )
                              "
                              @click="makePrimary(bu)"
                            >
                              <v-icon>mdi-crown</v-icon>
                            </z-confirm-button>
                          </td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </v-card-text>
                </v-card>

                <v-card flat tile v-if="t.name == 'Supervisors'">
                  <v-card-text>
                    <v-btn
                      color="blue"
                      x-small
                      style="float: right"
                      class="absolute-client-headers"
                      :to="'/settings/supervisor/create?forCorp=' + vendor._id"
                      :target="singlePage ? '_blank' : ''"
                    >
                      <h3>{{ $i18n.t("Add New") }}</h3>
                    </v-btn>
                    <v-simple-table>
                      <thead>
                        <tr>
                          <th class="primary--text">{{ $i18n.t("Name") }}</th>
                          <th class="primary--text">{{ $i18n.t("Phone") }}</th>
                          <th class="primary--text">{{ $i18n.t("Email") }}</th>
                          <th class="primary--text">{{ $i18n.t("Entity") }}</th>
                          <th class="primary--text">{{ $i18n.t("Role") }}</th>
                          <th class="text-right primary--text"></th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr
                          v-for="(superv, index) in supervisorList"
                          :key="index"
                        >
                          <td>
                            <v-icon v-if="superv.isCorpAdmin"
                              >mdi-medal-outline</v-icon
                            >
                            {{ superv.name }}
                          </td>
                          <td>{{ superv.countryCode + " " + superv.phone }}</td>
                          <td>{{ superv.email }}</td>
                          <td>{{ superv.entityName }}</td>
                          <td>{{ superv.roleName }}</td>
                          <td>
                            <v-btn
                              class="float-right"
                              color="primary"
                              small
                              fab
                              text
                              dark
                              :to="'/settings/supervisor/' + superv._id"
                              :target="singlePage ? '_blank' : ''"
                            >
                              <v-icon>mdi-pencil</v-icon>
                            </v-btn>

                            <z-confirm-button
                              v-if="!superv.isCorpAdmin"
                              class="float-right"
                              color="info"
                              small
                              fab
                              text
                              dark
                              :loading="loading"
                              :message="
                                $i18n.t(
                                  'Do you want to make this supervisor SuperAdmin ?'
                                )
                              "
                              @click="makeSuperAdmin(superv)"
                            >
                              <v-icon>mdi-crown</v-icon>
                            </z-confirm-button>
                          </td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </v-card-text>
                </v-card>

                <v-card flat tile v-if="t.name == 'Garages'">
                  <v-card-text>
                    <v-btn
                      color="blue"
                      x-small
                      style="float: right"
                      class="absolute-client-headers"
                      :to="'/garage/create?forCorp=' + vendor._id"
                      :target="singlePage ? '_blank' : ''"
                    >
                      <h3>{{ $i18n.t("Add New") }}</h3>
                    </v-btn>
                    <v-simple-table>
                      <thead>
                        <tr>
                          <th class="primary--text">{{ $i18n.t("Name") }}</th>
                          <th class="primary--text">
                            {{ $i18n.t("Address") }}
                          </th>
                          <th class="text-right primary--text">
                            {{ $i18n.t("Action") }}
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr v-for="(garage, index) in garageList" :key="index">
                          <td>{{ garage.name }}</td>
                          <td>
                            {{ garage.addr.addressLine }},
                            {{ garage.addr.city }}, {{ garage.addr.state }},
                            {{ garage.addr.country }}
                          </td>
                          <td>
                            <v-btn
                              class="float-right"
                              color="primary"
                              small
                              fab
                              text
                              dark
                              :to="'/settings/garage/' + garage._id"
                              :target="singlePage ? '_blank' : ''"
                            >
                              <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                            <z-confirm-button
                              class="float-right"
                              color="red"
                              small
                              fab
                              text
                              dark
                              :loading="loading"
                              :message="
                                $i18n.t(
                                  'Do you want to make this supervisor SuperAdmin ?'
                                )
                              "
                              @click="deleteGarage(garage)"
                            >
                              <v-icon>mdi-trash-can-outline</v-icon>
                            </z-confirm-button>
                          </td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs>
          </keep-alive>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet, doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import EntityRow from "@/views/entity/EntityRow.vue";
import EntityEdit from "@/views/entity/EntityEdit.vue";

@Component({
  components: {
    EntityRow,
    EntityEdit,
  },
  props: {
    singlePage: {
      default: false,
    },
    vendor_id: {
      default: null,
    },
  },
})
export default class VendorEdit extends Vue {
  vendor = null;
  tab = null;
  id = null;
  addnewEntity = false;
  tabs = [
    { name: "Profile", icon: "mdi-train-car" },
    // { name: "Entities", icon: "mdi-domain" },
    { name: "Supervisors", icon: "mdi-account-tie" },
    { name: "Garages", icon: "mdi-domain" },
  ];
  entityList = [];
  supervisorList = [];
  garageList = [];

  get loading() {
    return common.loading;
  }

  async save() {
    try {
      common.setLoading(true);
      const response = await doPost(
        "/api/corp/" + this.id + "/update",
        this.vendor
      );
      common.setLoading(false);
      common.showMessage("Vendor Saved Successfully");

      if (this.singlePage) {
        this.$emit("select", {
          name: response.vendor.name,
          _id: response._id,
        });
        this.corporate = null;
      }
      if (!this.id) {
        this.$router.push("/settings/vendor/" + response._id);
      } else {
        this.get(response._id);
      }
    } catch (e) {
      common.setError(e.message);
      common.setLoading(false);
    }
  }

  async get(id) {
    try {
      const response = await doGet("/api/corp/" + id + "/detail");
      this.vendor = response;
      this.id = response._id;
      this.getEntitiesbyCORP(this.vendor._id);
      this.getSupervisorsbyCORP(this.vendor._id);
      this.getGaragesbyCORP(this.vendor._id);
    } catch (e) {
      common.setError(e.message);
    }
  }

  async getEntitiesbyCORP(corp_id) {
    try {
      this.addnewEntity = false;
      this.entityList = await doGet("/api/entity/" + corp_id + "/corp/list");
    } catch (e) {
      console.log(e.message);
    }
  }

  async getSupervisorsbyCORP(corp_id) {
    try {
      this.supervisorList = await doGet(
        "/api/supervisor/getAllSupervisor?corp_id=" + corp_id
      );
    } catch (e) {
      console.log(e.message);
    }
  }

  async getGaragesbyCORP(corp_id) {
    try {
      this.garageList = await doGet("/api/corp/garage/" + corp_id + "/list");
    } catch (e) {
      console.log(e.message);
    }
  }

  async makeSuperAdmin(superv) {
    try {
      await doGet(
        "/api/supervisor/" +
          superv._id +
          "/makeSuperAdmin?corp_id=" +
          superv.adminOf
      );
      this.get(this.vendor._id);
      common.showMessage("Successfully save");
    } catch (e) {
      common.setError(e.message);
    }
  }

  async deleteEntity(bu) {
    try {
      await doGet("/api/entity/" + bu._id + "/delete/entity");
      common.showMessage("Deleted Successfully");
      this.getEntitiesbyCORP(this.vendor._is);
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }

  async deleteGarage(garage) {
    try {
      await doGet("/api/config/deleteGarage/" + garage._id);
      common.showMessage("Deleted Successfully");
      this.getGaragesbyCORP(this.vendor._id);
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }

  async makePrimary(bu) {
    try {
      await doGet("/api/entity/" + bu._id + "/primary/entity");
      common.showMessage("Successfully done");
      this.get(this.vendor._id);
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }

  async mounted() {
    if (this.singlePage) {
      if (this.vendor_id) {
        await this.get(this.vendor_id);
      }
    } else if (this.$route.params.id) {
      await this.get(this.$route.params.id);
    }
  }

  newItem(itemList) {
    if (!itemList) itemList = [];
    itemList.push({});
    return itemList;
  }

  remove(list, _index) {
    list.splice(_index, 1);
  }
}
</script>

<style scoped>
.pac-target-input {
  width: 50%;
  border: 1px solid #dfdfdf;
  height: 30px;
  padding: 10px 20px;
  z-index: 1;
  background: white;
  margin-left: 25%;
  position: absolute;
  margin-top: 10px;
}
.client-headers {
  text-transform: none;
  color: #555;
  top: -10px;
  /* left: 10px; */
  right: 10px;
  font-size: 12px;
}
.absolute-client-headers {
  text-transform: none;
  color: #555;
  top: -10px;
  position: absolute;
  right: 10px;
  font-size: 9px;
}
</style>
